import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {moduleConfig} from "../config";

const useTools = () => {
    // Read-only module (FNP-585): no Add/Delete/Filter — the sweep scans the whole
    // platform, so there is nothing to filter. Reload only.
    const tools = [];

    tools.push(<ReloadRecordsButton key='reload'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            tools={useTools()}
        />
    );
};
